# frozen_string_literal: true

require 'view/game/actionable'

module View
  module Game
    class BlindBid < Snabberb::Component
      include Actionable

      # The player bidding; the current entity unless the round view says otherwise.
      needs :entity, default: nil

      def render
        @round = @game.round
        @current_entity = @entity || @round.current_entity
        @step = @round.active_step

        choices = @step.blind_choices(@current_entity)
        @count = choices.size
        max = @step.blind_max(@current_entity)

        # A step with a minimum bid starts each bid at it and offers a Pass button in place of a zero bid.
        min_bids = @step.respond_to?(:blind_min)

        input = {}
        rows = choices.map.with_index do |entity, idx|
          label = @step.blind_label(entity)

          attrs = {
            type: 'number',
            min: 0,
            max: max,
            value: 0,
            size: max.to_s.size + 2,
          }
          attrs[:min] = attrs[:value] = @step.blind_min(entity) if min_bids
          attrs[:step] = @step.blind_increment if @step.respond_to?(:blind_increment)
          input[idx] = h('input.no_margin',
                         style: {
                           height: '1.6rem',
                           width: '4rem',
                           padding: '0 0 0 0.2rem',
                           margin: '0',
                         },
                         attrs: attrs)
          h(:tr, [
            h(:td, [label]),
            h(:td, [input[idx]]),
          ])
        end

        bid = lambda do |amounts|
          process_action(Engine::Action::BlindBid.new(
                           @current_entity,
                           bids: amounts,
                         ))
        end

        click = lambda do
          amounts = input.keys.map { |k| input[k].JS['elm'].JS['value'].to_i }
          if min_bids && amounts.all?(&:zero?)
            store(:flash_opts, 'Enter a bid, or press Pass')
          else
            bid.call(amounts)
          end
        end

        button_style = { padding: '0.2rem 0.2rem', marginRight: '0.5rem' }
        buttons = [h('button', { style: button_style, on: { click: click } }, 'Enter Bid')]
        buttons << h('button', { style: button_style, on: { click: -> { bid.call([0] * @count) } } }, 'Pass') if min_bids

        table_props = {
          style: {
            border: '1px solid',
          },
        }

        h(:div, [
          h(:table, table_props, [h(:tbody, rows)]),
          *buttons,
        ])
      end
    end
  end
end
